import React, { Component } from 'react';
import {Button, Modal, Badge, Card} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './AnnouncementItem.css';

const locale = 'en-US';
const dateFormatOptionsWithTime = { month: 'long' , day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true };
const dateFormatOptionsWithoutTime = { month: 'long' , day: 'numeric' };

export class AnnouncementItem extends Component {
    render() {
      return <Card border='light' className='announcement linebreak'>
        <Card.Body>
            <DateBadge date={this.props.date} displayDate={this.props.displayDate} /><Title title={this.props.title} body={this.props.body} />&nbsp;-&nbsp;
            {this.props.body}
            {(this.props.loc || this.props.link) ?
              <br/>
            : null}
            <Location locLink={this.props.locLink} loc={this.props.loc} />
            <br/>
            <Link link={this.props.link} linkText={this.props.linkText} />
            {/*<MoreInfoModal cancelled={this.props.cancelled} title={this.props.title} moreInfo={this.props.moreInfo} image={this.props.image} link={this.props.link} body={this.props.body} />*/}
        </Card.Body>
        </Card>;
    }
  }

class Link extends Component {
  render(){
    if (this.props.link)
    {
      if (this.props.linkText) {
        return <a href={this.props.link}>{this.props.linkText}</a>;
      }
      else {
        return <a href={this.props.link}>Link</a>;
      }
    }
    return null;
  }
}
class DateBadge extends Component {
  render() {
    const date = this.props.date
    if(this.props.displayDate?.toLowerCase() == '\\nodate'){
      return <span></span>
    }
    if (this.props.displayDate)
    {
      return <span><Badge bg='secondary'>{
        this.props.displayDate
      }</Badge>&nbsp;</span>
    }
    if (date)
    {
      if(date.getHours() > 0){
        return <span><Badge bg='secondary'>{
          new Intl.DateTimeFormat(locale, dateFormatOptionsWithTime).format(date)
        }</Badge>&nbsp;</span>
      } else {
        return <span><Badge bg='secondary'>{
          new Intl.DateTimeFormat(locale, dateFormatOptionsWithoutTime).format(date)
        }</Badge>&nbsp;</span>
      }
    }
    return null;
  }
}

class Location extends Component {
  render() {
    const locationLink = this.props.locLink;
    const location = this.props.loc;
    if (location && locationLink)
    {
      return <a style={{fontSize: '1em'}} href={`${locationLink}`} target="_blank" rel="noopener noreferrer">Location: {location}</a>
    } else
    if (locationLink) 
    {
      return <a style={{fontSize: '1em'}} href={`${locationLink}`} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon='map-marker' />&nbsp;</a>
    } else 
    if (location) {
      return <span style={{fontSize: '1em'}}>Location: {location}</span>
    }
    return null;
  }
}

class Title extends Component {
  render() {
    return <strong>{this.props.title}</strong>;
  }
  
}

class MoreInfoModal extends Component {
  constructor(props) {
    super(props);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {
    if (this.props.moreInfo && this.props.link)
    {
      return <div className="clearfix">
        <Button className="pull-right" bsStyle="info" disabled={this.props.cancelled} onClick={this.handleShow}>
          More Info {this.props.cancelled}
        </Button>

        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title><a href={this.props.link} alt={this.props.title}>{this.props.title}</a></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{this.props.moreInfo === ' '
                ? this.props.body
                : this.props.mofeInfo}</p>
              <hr />
            <span>{this.props.image ? <img className="img img-responsive" src={`${this.props.image}`} alt={`${this.props.title}`}/> : ''}</span>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleClose}>Close</Button>
          </Modal.Footer>
        </Modal>
        </div>
    }
    else if (this.props.moreInfo)
    {
      return <div className="clearfix">
        <Button className="pull-right" bsStyle={this.props.cancelled ? "default" : "info"} disabled={this.props.cancelled} onClick={this.handleShow}>
          More Info
        </Button>

        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{this.props.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <p>{this.props.moreInfo === ' '
              ? this.props.body
              : this.props.mofeInfo}</p>
            <hr />
            <span>{this.props.image ? <img className="img img-responsive" src={`${this.props.image}`} alt={`${this.props.title}`}/> : ''}</span>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleClose}>Close</Button>
          </Modal.Footer>
        </Modal>
        </div>
    }
    return null;
  }
}